import React, { useState } from 'react'
import {
  Create,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Grid } from '@mui/material'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'
import { DateRangeArray } from './logic/DateRangeArray'
import dayjs from 'dayjs'

export const DueDateRangeCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [isLoading, setIsLoading] = useState()

  const formatDate = (date) => {
    if (dayjs(date).isValid()) {
      return dayjs(date).format('YYYY-MM-DD')
    }
    return null
  }

  const onSuccess = async (data) => {
    setIsLoading(true)
    try {
      const promises = [
        await createDateRange(data.date_range_relation, data.id),
      ]
      await Promise.all(promises)
      setTimeout(() => {
        notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.entity.due-date-range') },
        })
      }, 1000)
    } catch (error) {
    } finally {
      setIsLoading(false)
      redirect('/due-date-range')
    }
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.due-date-range') }
    })
  }

  const createDateRange = async (dateRanges, due_date_range_id) => {
    const dateRangesToCreate = dateRanges?.filter((elem) => elem?.new_register)
    if (dateRangesToCreate?.length > 0) {
      try {
        const promises = dateRangesToCreate.map(async (elem) => {
          // Validar y formatear fechas antes de enviar
          elem.date_from = formatDate(elem.date_from)
          elem.date_to = formatDate(elem.date_to)
          elem.date_final = formatDate(elem.date_final)
          elem.due_date_range_id = due_date_range_id
          delete elem._id
          delete elem.new_register
          const response = await dueDateServices.createDateRange(elem)
          return response
        })
        const results = await Promise.all(promises)
        return results
      } catch (error) {
        notify(`ra.notification.create_error_date_range`, {
          type: 'error',
        })
        return false
      }
    }
    return true
  }


  const transform = (data) => {
    let obj = {
      ...data,
    }

    if (data?.date_range_relation?.length > 0) {
      obj?.date_range_relation?.forEach((elem) => {
        elem.due_date_range_id = data.id
      })
    }
    return obj
  }

  const CardCrudBottomButtons = ({ btnSave }) => (
    <Toolbar>
      {(btnSave && !isLoading) && <SaveButton />}
    </Toolbar>
  );

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null} transform={transform}>
      <CardCommon title={translate('ra.title.create_due_date_range')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true}/>}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
          </Grid>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.date_ranges')} lg={10} md={10} xs={10}>
              <DateRangeArray />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}